import get from 'transmute/get';
export const getTypingMessageStyle = get('style');
export const getTypingMessageLabel = get('label');